import { Routes } from '@angular/router';
import { AccesoComponent } from './acceso/acceso.component';
import { PendientesComponent } from './pendientes/pendientes.component';
import { TableroComponent } from './tablero/tablero.component';
import { ConversacionesComponent } from './conversaciones/conversaciones.component';
import { PacientesComponent } from './pacientes/pacientes.component';
import { guardiaSesion } from './core/sesion.service';

export const routes: Routes = [
  { path: 'acceso', component: AccesoComponent },
  { path: 'pendientes', component: PendientesComponent, canActivate: [guardiaSesion] },
  { path: 'procesos', component: TableroComponent, canActivate: [guardiaSesion] },
  { path: 'tablero', redirectTo: 'procesos', pathMatch: 'full' },
  { path: 'conversaciones', component: ConversacionesComponent, canActivate: [guardiaSesion] },
  { path: 'pacientes', component: PacientesComponent, canActivate: [guardiaSesion] },
  { path: 'pacientes/:id', component: PacientesComponent, canActivate: [guardiaSesion] },
  { path: '', pathMatch: 'full', redirectTo: 'pendientes' },
  { path: '**', redirectTo: 'pendientes' }
];
